var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-button-wrapper"},[_vm._v(" "+_vm._s(_vm.player.name)+" "),_c('toggle-button',{attrs:{"id":_vm.player.id,"height":35,"width":65,"value":_vm.player.value,"sync":""},on:{"change":_vm.toggleButton}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }